import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import IconButton from '../../components/common/IconButton';

export default function InstructionGeneratorListPage (props) {
  return (<div>
    <h1>Instruction Generator</h1>
    <Row>
      <Col md={2}>
        {/* New instruction button (+) */}
        <LinkContainer to="/dashboard/instruction-generator/create">
          <IconButton wide marginBottom title="New instruction"/>
        </LinkContainer>
      </Col>
    </Row>
    <h2>Instruction list: </h2>
    <p>Instruction 1</p>
    <p>Instruction 2</p>
  </div>);
}
